import tracking from '../../utils/tracking';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  const GENERIC_CLASS = 'scAnalyticsGoals';
  const GENERIC_ATTR_KEY = 'data-sc-goal-id';

  return () => {
    $(() => {
      $(window.document).on('click', `.${GENERIC_CLASS}`, (ev) => {
        const t = ev.currentTarget;
        const goalID = t.getAttribute(GENERIC_ATTR_KEY);
        
        if (goalID) {
          tracking.sendScTracking(goalID);
        }
      });
    });
  };
})(jQuery, window);